import { render, staticRenderFns } from "./QuestionnairePage.vue?vue&type=template&id=35505d60"
import script from "./QuestionnairePage.vue?vue&type=script&lang=ts"
export * from "./QuestionnairePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports